/* eslint-disable import/prefer-default-export */
export const selectAuth = (state) => state.auth;
